import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Skeleton } from 'primeng/skeleton';
import { MatIcon } from '../mat-icon/mat-icon';
import { RouterLink } from '@angular/router';

export interface ListItem {
  text: string;
  sub?: string;
  add?: string;
  addClass?: string;
}

@Component({
  selector: 'app-list-card',
  imports: [TranslatePipe, Skeleton, MatIcon, RouterLink],
  templateUrl: './list-card.html',
  styleUrl: './list-card.scss',
})
export class ListCard {
  title = input<string>("Card Title");
  items = input<ListItem[]>([]);
  additionalLinkTitle = input<string>(undefined);
  additionalLinkUrl = input<string>(undefined);

  loading = input<boolean>(false);
  disabled = input<boolean>(false);
  disabledText = input<string>("No Content");

  emptyText = input<string>("No Content");
}
